/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */

import { format, parse, differenceInDays } from 'date-fns';

function formattedDate(fields) {
    const {
        start_date, end_date, start_time, end_time,
    } = fields;

    const eventStartDate = new Date(start_date);

    const eventStartTime = start_time
        ? format(
            new Date(parse(start_time, 'HH:mm:ss', new Date())),
            ' h:mm aaa',
        )
        : '';
    const eventEndDate = new Date(end_date);

    const diff = differenceInDays(eventEndDate, eventStartDate);

    if (diff < 1) {
        return `${format(eventStartDate, 'do MMM')}${eventStartTime}`;
    }
    const eventEndTime = end_time
        ? format(new Date(parse(end_time, 'HH:mm:ss', new Date())), ' h:mm aaa')
        : '';

    let startFormat;
    let endFormat;

    if (format(eventStartDate, 'y') !== format(eventEndDate, 'y')) {
        startFormat = format(eventStartDate, 'do MMM y');
        endFormat = format(eventEndDate, 'do MMM y');
    } else if (format(eventStartDate, 'M') !== format(eventEndDate, 'M')) {
        startFormat = format(eventStartDate, 'do');
        endFormat = format(eventEndDate, 'do MMM');
    } else {
        startFormat = format(eventStartDate, 'do MMM');
        endFormat = format(eventEndDate, 'do MMM');
    }

    return `${startFormat}${eventStartTime} - ${endFormat}${eventEndTime}`;
}

const createItem = event => {
    const { thumbnail } = event._embedded && event._embedded['wp:featuredmedia']
        ? event._embedded['wp:featuredmedia'][0].media_details.sizes
        : {};
    const terms = event._embedded && event._embedded['wp:term']
        ? event._embedded['wp:term'][0]
        : [];
    return `<a class="grid-list__item" href="${
        event.acf && event.acf.custom_link ? event.acf.custom_link : event.link
    }">
        ${
    thumbnail
        ? `<img width="${thumbnail.width}" height="${thumbnail.height}" src="${thumbnail.source_url}" class="attachment-thumbnail size-thumbnail wp-post-image" alt=""></img>`
        : ''
}
        <ul class="grid-list__terms">
            ${terms
        .map(term => (term.acf && term.acf.colour
            ? `<li class="${term.slug}" style="background-color: ${term.acf.colour};">${term.name}</li>`
            : `<li class="${term.slug}">${term.name}</li>`))
        .join('')}
        </ul>
        <div class="date">${formattedDate(event.acf)}</div>
        <h3>${event.title.rendered}</h3>
        ${event.acf.short_description}
        </a>
        `;
};

const noResults = (date, term) => `
<section class="no-results not-found">
<header class="page-header">
<h1 class="page-title">Nothing Found</h1>
<h2>No results found for: ${
    date
        ? format(
            parse(date, 'EEEE-d-MMMM-yyyy', new Date()),
            'EEEE d MMMM yyyy',
        )
        : term
}</h2>
</header>
</section>`;

const updatePage = (events, url, date, term) => {
    window.history.pushState('', '', url);
    const wrapper = document.getElementById('event-wrapper');
    if (events.length) {
        let output = '';
        events.forEach(event => {
            output += createItem(event);
        });
        wrapper.innerHTML = output;
    } else {
        wrapper.innerHTML = noResults(date, term);
    }
};

const EventFilter = () => {
    // eslint-disable-next-line no-undef
    const siteUrl = WPURLS.siteurl;

    const filter = document.getElementById('event-filter');
    if (!filter) return;
    const tabLinks = Array.from(filter.querySelectorAll('.tab__link'));
    const tabs = Array.from(filter.querySelectorAll('.event-filter'));

    const eventNav = document.getElementById('event-nav');

    let currentDay = filter.getAttribute('data-day');
    let currentTerm = filter.getAttribute('data-term');
    const days = Array.from(filter.querySelectorAll('.event-filter.day a'));
    const availableDays = days.map(day => day.getAttribute('data-date'));
    const terms = Array.from(
        filter.querySelectorAll('.event-filter.category a'),
    );
    const availableTerms = terms.map(term => term.getAttribute('data-term'));

    let currentTab = currentDay ? 0 : 1;

    const updateDayNav = () => {
        const eventNext = document.getElementById('event-next');
        const eventPrev = document.getElementById('event-prev');
        const currentIndex = availableDays.indexOf(currentDay);
        const nextIndex = currentIndex + 1;
        const prevIndex = currentIndex - 1;

        if (prevIndex < 0) {
            eventPrev.disabled = true;
        }

        if (availableDays[prevIndex]) {
            eventPrev.setAttribute('data-date', availableDays[prevIndex]);
            eventPrev.setAttribute(
                'data-url',
                days[prevIndex].getAttribute('href'),
            );
        }

        if (nextIndex === availableDays.length) {
            eventNext.disabled = true;
        }

        if (availableDays[nextIndex]) {
            eventNext.setAttribute('data-date', availableDays[nextIndex]);
            eventNext.setAttribute(
                'data-url',
                days[nextIndex].getAttribute('href'),
            );
        }
    };

    if (eventNav && currentTab === 0) {
        updateDayNav();
    }

    const updateCatNav = () => {
        const eventNext = document.getElementById('event-next');
        const eventPrev = document.getElementById('event-prev');
        const currentIndex = availableTerms.indexOf(currentTerm);
        const nextIndex = currentIndex + 1;
        const prevIndex = currentIndex - 1;

        if (prevIndex < 0) {
            eventPrev.disabled = true;
        }

        if (terms[prevIndex]) {
            eventPrev.setAttribute(
                'data-url',
                terms[prevIndex].getAttribute('href'),
            );
        }

        if (nextIndex === terms.length) {
            eventNext.disabled = true;
        }

        if (terms[nextIndex]) {
            eventNext.setAttribute(
                'data-url',
                terms[nextIndex].getAttribute('href'),
            );
        }
    };

    if (eventNav && currentTab === 1) {
        updateCatNav();
    }

    if (eventNav) {
        const navs = Array.from(
            eventNav.querySelectorAll('button.btn-event-nav'),
        );
        navs.forEach(nav => {
            nav.addEventListener('click', async event => {
                const url = event.target.getAttribute('data-url');
                window.location.href = url;
            });
        });
    }

    tabLinks.forEach((tabLink, i) => {
        const isActive = tabLink.classList.contains('active');
        if (isActive) {
            currentTab = i;
        }

        tabLink.addEventListener('click', event => {
            currentTab = i;
            const tabName = event.target.getAttribute('data-tab');
            tabLinks.forEach(link => {
                link.className = link.className.replace(' active', '');
            });
            tabs.forEach(tab => {
                tab.style.display = 'none';
            });
            filter.getElementsByClassName(tabName)[0].style.display = 'flex';
            event.currentTarget.className += ' active';

            if (currentTab === 0) {
                days[0].click();
                updateDayNav();
            } else {
                terms[0].click();
                updateCatNav();
            }
        });
    });

    tabs.forEach((tab, i) => {
        if (i !== currentTab) {
            tab.style.display = 'none';
        }
    });

    const clearActiveFilters = event => {
        days.forEach(el => {
            if (el !== this) el.parentElement.classList.remove('active');
        });
        terms.forEach(el => {
            if (el !== this) el.parentElement.classList.remove('active');
        });
        event.target.parentElement.classList.add('active');
    };

    days.forEach(day => {
        day.addEventListener('click', async event => {
            event.preventDefault();
            event.stopPropagation();
            event.target.classList.add('loading');
            clearActiveFilters(event);
            const date = event.target.getAttribute('data-date');
            const url = event.target.getAttribute('href');
            const events = await (
                await fetch(
                    `${siteUrl}/wp-json/wp/v2/event?start_date=${date}&order_by=start_date&_embed&per_page=100`,
                )
            ).json();
            updatePage(events, url, date, null);
            event.target.classList.remove('loading');
            currentDay = date;
            updateDayNav();
        });
    });

    terms.forEach(term => {
        term.addEventListener('click', async event => {
            event.preventDefault();
            event.target.classList.add('loading');
            clearActiveFilters(event);
            const termId = event.target.getAttribute('data-term_id');
            const url = event.target.getAttribute('href');
            const events = await (
                await fetch(
                    `${siteUrl}/wp-json/wp/v2/event?term_id=${termId}&order_by=start_date&_embed`,
                )
            ).json();
            updatePage(events, url, null, term);
            event.target.classList.remove('loading');
            currentTerm = event.target.getAttribute('data-term');
            updateCatNav();
        });
    });
};
export default EventFilter;
